export default __webpack_public_path__ + "static/cta-dont-1d17dcbe37e9a129bf7f6a8bad5780bef2c5810b5d101f51bc8fd2c57c5109fd.png";